module.exports = __webpack_public_path__ + "static/img/Signature.99a82b75.svg";